import { Row, Col } from 'antd';
import { 
    TagsOutlined, 
    CheckCircleOutlined, 
    CloseCircleOutlined 
} from '@ant-design/icons';
import StatCard from '@/components/UI/Cards/StatCard';
import { useCategoryData } from '../hooks/useCategoryData';

/**
 * Category card component displaying category statistics
 * Uses real data from the API
 */
const CategoryCard = () => {
    // Use custom hook for category data
    const { 
        totalCategories,
        activeCategories,
        inactiveCategories,
        isLoading, 
        isError,
        error 
    } = useCategoryData();

    if (isLoading) {
        return (
            <Row gutter={[16, 16]}>
                {[1, 2, 3].map((index) => (
                    <Col xs={24} sm={12} md={8} key={index}>
                        <div className="bg-white rounded-lg border border-gray-200 p-4 flex items-center space-x-4 shadow-sm">
                            <div className="w-10 h-10 rounded-full bg-gray-200 animate-pulse"></div>
                            <div className="flex flex-col flex-1">
                                <div className="h-4 bg-gray-200 rounded animate-pulse mb-2 w-20"></div>
                                <div className="h-6 bg-gray-200 rounded animate-pulse w-12"></div>
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        );
    }

    if (isError) {
        return (
            <Row gutter={[16, 16]}>
                <Col span={24}>
                    <div className="bg-white rounded-lg border border-gray-200 p-4 text-center">
                        <p className="text-red-600">
                            Error loading categories data: {error?.message || 'Unknown error'}
                        </p>
                    </div>
                </Col>
            </Row>
        );
    }

    // Data configuration for category statistics
    const cardData = [
        {
            icon: TagsOutlined,
            title: "All Categories",
            count: totalCategories ?? 0,
            iconColor: "text-orange-600",
            iconBgColor: "bg-orange-100"
        },
        {
            icon: CheckCircleOutlined,
            title: "Active Categories",
            count: activeCategories ?? 0,
            iconColor: "text-green-600",
            iconBgColor: "bg-green-100"
        },
        {
            icon: CloseCircleOutlined,
            title: "Inactive Categories",
            count: inactiveCategories ?? 0,
            iconColor: "text-gray-600",
            iconBgColor: "bg-gray-100"
        }
    ];

    return (
        <Row gutter={[16, 16]}>
            {cardData.map((stat, index) => (
                <Col xs={24} sm={12} md={8} key={index}>
                    <StatCard
                        icon={stat.icon}
                        title={stat.title}
                        count={stat.count}
                        iconColor={stat.iconColor}
                        iconBgColor={stat.iconBgColor}
                    />
                </Col>
            ))}
        </Row>
    );
};

export default CategoryCard;